import {
  Paper,
  styled,
  TableRow,
  TableCell,
  TableContainer,
  TableBody,
} from '@mui/material';
import Grid from '@mui/material/Grid2';

export const ActionGrid = styled(Grid)(({ _ }) => ({
  background: 'black',
}));

export const ViewportGrid = styled(Grid)(({ _ }) => ({
  height: '65vh',
}));

export const StudyListGrid = styled(Grid)(({ _ }) => ({
  height: '25vh',
}));

export const StudyListPaper = styled(Paper)(({ _ }) => ({
  background: 'dimgrey',
}));

export const StudyListTableContainer = styled(TableContainer)(({ _ }) => ({
  height: '25vh',
  background: 'dimgrey',
}));

export const StudyListTableHeadCell = styled(TableCell)(({ _ }) => ({
  background: 'dimgrey',
  color: 'white',
}));

export const StudyListTableBody = styled(TableBody)(({ _ }) => ({}));

export const StudyListTableBodyRow = styled(TableRow)(({ _, selected }) => ({
  ...(selected && {
    background: 'royalblue',
  }),
}));

export const StudyListTableBodyCellLight = styled(TableCell)(({ _ }) => ({
  background: 'darkgrey',
  color: 'white',
  wordBreak: 'break-all',
  '&:hover': {
    cursor: 'pointer',
  },
}));

export const StudyListTableBodyCellDark = styled(TableCell)(({ _ }) => ({
  background: 'grey',
  color: 'white',
  '&:hover': {
    cursor: 'pointer',
  },
}));

export const StudyListTableBodyCellSelected = styled(TableCell)(({ _ }) => ({
  background: 'royalblue',
  color: 'white',
  '&:hover': {
    cursor: 'pointer',
  },
}));
